import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { PostingPlanListViewView, PostingPlanListViewViewProps } from './PostingPlanListView.view';
import { PostingPlanHelpers } from '../postingPlanHelpers';
import { TimeslotDay } from '../../../../models/graphql';
import { TimeslotMappedData } from '../PostingPlan.view';
import { CalendarDataType, PostingPlanCellDataType } from '../../../../models/calendar';
import { format } from 'date-fns-tz';

export type PostingPlanListViewControllerProps = Omit<
  PostingPlanListViewViewProps,
  'selectedDay' | 'setSelectedDay' | 'events' | 'startOfWeek'
> & {
  setLoading: Dispatch<SetStateAction<boolean>>;
  events: CalendarDataType<PostingPlanCellDataType>;
  // extend your PostingPlanListViewViewProps
};

export const getCurrentWeekDay = () => {
  return format(new Date(), 'EEEE').toUpperCase() as TimeslotDay;
};

export const PostingPlanListViewController = (props: PostingPlanListViewControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const today = getCurrentWeekDay();

  // We need to create a new arr in the memory via spread since sort will modify the original array, and it will cause rerenders

  const [selectedDay, setSelectedDay] = useState<TimeslotDay>(today);
  const [events, setEvents] = useState<TimeslotMappedData[]>(
    PostingPlanHelpers.filterByDay(props.events, selectedDay, props.startDayOfWeek)
  );
  const { events: propEvents, startDayOfWeek, setLoading } = props;
  useEffect(() => {
    if (propEvents && selectedDay) {
      const filtered = PostingPlanHelpers.filterByDay([...propEvents], selectedDay, startDayOfWeek);
      setEvents(filtered);
      setLoading(false);
    }
  }, [selectedDay, setLoading, propEvents, startDayOfWeek]);

  const viewProps: PostingPlanListViewViewProps = {
    events,
    selectedDay,
    setSelectedDay,
    startDayOfWeek: props.startDayOfWeek
  };
  return <PostingPlanListViewView {...viewProps} />;
};
